import { render } from "./Services.vue?vue&type=template&id=65878d57"
const script = {}
script.render = render

export default script